/**
 * Aztrix
 * Smart address book for individuals and organisations, respecting privacy.
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface BulkRequestRepresentation {
  types?: Array<BulkRequestRepresentation.TypesEnum>;
  contactIds?: Array<string>;
}
export namespace BulkRequestRepresentation {
  export type TypesEnum =
    | 'USERNAME'
    | 'FIRST_NAME'
    | 'MIDDLE_NAME'
    | 'LAST_NAME'
    | 'NAME'
    | 'AVATAR'
    | 'GENDER'
    | 'BIRTHDAY'
    | 'FOUNDED'
    | 'DISSOLVED'
    | 'DAY'
    | 'MONTH'
    | 'YEAR'
    | 'EMAIL'
    | 'MOBILE_PHONE'
    | 'PHONE'
    | 'FAX'
    | 'WEBSITE'
    | 'BIC'
    | 'JOB_TITLE'
    | 'INDUSTRY'
    | 'GROUP'
    | 'REGION'
    | 'ADDRESS'
    | 'STREET'
    | 'COUNTRY'
    | 'BUILDING'
    | 'BOX'
    | 'LOCALITY'
    | 'NUMBER'
    | 'ZIP'
    | 'DISTRICT'
    | 'PROVINCE'
    | 'SUBURB'
    | 'STATE'
    | 'COUNTY'
    | 'LAT_LONG'
    | 'FACEBOOK'
    | 'YOUTUBE'
    | 'INSTAGRAM'
    | 'WHATSAPP'
    | 'WECHAT'
    | 'TIKTOK'
    | 'FACEBOOK_MESSENGER'
    | 'TELEGRAM'
    | 'SNAPCHAT'
    | 'PINTEREST'
    | 'TWITTER'
    | 'REDDIT'
    | 'LINKEDIN'
    | 'VIMEO'
    | 'DISCORD'
    | 'TWITCH'
    | 'TUMBLR'
    | 'MASTODON'
    | 'PATREON'
    | 'KICKSTARTER'
    | 'INDIEGOGO'
    | 'GOFUNDME'
    | 'TAKEAWAY'
    | 'UBEREATS'
    | 'DELIVEROO'
    | 'SHIPTO'
    | 'WEIBO'
    | 'QQ'
    | 'KUAISHOU'
    | 'QZONE'
    | 'SKYPE'
    | 'NOTE'
    | 'ORGANISATION_NAME'
    | 'LEGAL_NAME'
    | 'LEGAL_FORM'
    | 'LEGAL_ID'
    | 'COMPANY_NUMBER'
    | 'JURISDICTION'
    | 'IMPORT_SOURCE'
    | 'PROPOSAL'
    | 'CATEGORY'
    | 'OPENING_HOURS'
    | 'CUSTOM'
    | 'FILE'
    | 'IMAGE'
    | 'FILE_KEY'
    | 'FILE_NAME'
    | 'TERMS_AND_CONDITIONS'
    | 'PRIVACY_POLICY'
    | 'DOCUMENT'
    | 'DOCUMENT_NAME'
    | 'ORGANISATION_TYPE';
  export const TypesEnum = {
    USERNAME: 'USERNAME' as TypesEnum,
    FIRST_NAME: 'FIRST_NAME' as TypesEnum,
    MIDDLE_NAME: 'MIDDLE_NAME' as TypesEnum,
    LAST_NAME: 'LAST_NAME' as TypesEnum,
    NAME: 'NAME' as TypesEnum,
    AVATAR: 'AVATAR' as TypesEnum,
    GENDER: 'GENDER' as TypesEnum,
    BIRTHDAY: 'BIRTHDAY' as TypesEnum,
    FOUNDED: 'FOUNDED' as TypesEnum,
    DISSOLVED: 'DISSOLVED' as TypesEnum,
    DAY: 'DAY' as TypesEnum,
    MONTH: 'MONTH' as TypesEnum,
    YEAR: 'YEAR' as TypesEnum,
    EMAIL: 'EMAIL' as TypesEnum,
    MOBILE_PHONE: 'MOBILE_PHONE' as TypesEnum,
    PHONE: 'PHONE' as TypesEnum,
    FAX: 'FAX' as TypesEnum,
    WEBSITE: 'WEBSITE' as TypesEnum,
    BIC: 'BIC' as TypesEnum,
    JOB_TITLE: 'JOB_TITLE' as TypesEnum,
    INDUSTRY: 'INDUSTRY' as TypesEnum,
    GROUP: 'GROUP' as TypesEnum,
    REGION: 'REGION' as TypesEnum,
    ADDRESS: 'ADDRESS' as TypesEnum,
    STREET: 'STREET' as TypesEnum,
    COUNTRY: 'COUNTRY' as TypesEnum,
    BUILDING: 'BUILDING' as TypesEnum,
    BOX: 'BOX' as TypesEnum,
    LOCALITY: 'LOCALITY' as TypesEnum,
    NUMBER: 'NUMBER' as TypesEnum,
    ZIP: 'ZIP' as TypesEnum,
    DISTRICT: 'DISTRICT' as TypesEnum,
    PROVINCE: 'PROVINCE' as TypesEnum,
    SUBURB: 'SUBURB' as TypesEnum,
    STATE: 'STATE' as TypesEnum,
    COUNTY: 'COUNTY' as TypesEnum,
    LAT_LONG: 'LAT_LONG' as TypesEnum,
    FACEBOOK: 'FACEBOOK' as TypesEnum,
    YOUTUBE: 'YOUTUBE' as TypesEnum,
    INSTAGRAM: 'INSTAGRAM' as TypesEnum,
    WHATSAPP: 'WHATSAPP' as TypesEnum,
    WECHAT: 'WECHAT' as TypesEnum,
    TIKTOK: 'TIKTOK' as TypesEnum,
    FACEBOOK_MESSENGER: 'FACEBOOK_MESSENGER' as TypesEnum,
    TELEGRAM: 'TELEGRAM' as TypesEnum,
    SNAPCHAT: 'SNAPCHAT' as TypesEnum,
    PINTEREST: 'PINTEREST' as TypesEnum,
    TWITTER: 'TWITTER' as TypesEnum,
    REDDIT: 'REDDIT' as TypesEnum,
    LINKEDIN: 'LINKEDIN' as TypesEnum,
    VIMEO: 'VIMEO' as TypesEnum,
    DISCORD: 'DISCORD' as TypesEnum,
    TWITCH: 'TWITCH' as TypesEnum,
    TUMBLR: 'TUMBLR' as TypesEnum,
    MASTODON: 'MASTODON' as TypesEnum,
    PATREON: 'PATREON' as TypesEnum,
    KICKSTARTER: 'KICKSTARTER' as TypesEnum,
    INDIEGOGO: 'INDIEGOGO' as TypesEnum,
    GOFUNDME: 'GOFUNDME' as TypesEnum,
    TAKEAWAY: 'TAKEAWAY' as TypesEnum,
    UBEREATS: 'UBEREATS' as TypesEnum,
    DELIVEROO: 'DELIVEROO' as TypesEnum,
    SHIPTO: 'SHIPTO' as TypesEnum,
    WEIBO: 'WEIBO' as TypesEnum,
    QQ: 'QQ' as TypesEnum,
    KUAISHOU: 'KUAISHOU' as TypesEnum,
    QZONE: 'QZONE' as TypesEnum,
    SKYPE: 'SKYPE' as TypesEnum,
    NOTE: 'NOTE' as TypesEnum,
    ORGANISATION_NAME: 'ORGANISATION_NAME' as TypesEnum,
    LEGAL_NAME: 'LEGAL_NAME' as TypesEnum,
    LEGAL_FORM: 'LEGAL_FORM' as TypesEnum,
    LEGAL_ID: 'LEGAL_ID' as TypesEnum,
    COMPANY_NUMBER: 'COMPANY_NUMBER' as TypesEnum,
    JURISDICTION: 'JURISDICTION' as TypesEnum,
    IMPORT_SOURCE: 'IMPORT_SOURCE' as TypesEnum,
    PROPOSAL: 'PROPOSAL' as TypesEnum,
    CATEGORY: 'CATEGORY' as TypesEnum,
    OPENING_HOURS: 'OPENING_HOURS' as TypesEnum,
    CUSTOM: 'CUSTOM' as TypesEnum,
    FILE: 'FILE' as TypesEnum,
    IMAGE: 'IMAGE' as TypesEnum,
    FILE_KEY: 'FILE_KEY' as TypesEnum,
    FILE_NAME: 'FILE_NAME' as TypesEnum,
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS' as TypesEnum,
    PRIVACY_POLICY: 'PRIVACY_POLICY' as TypesEnum,
    DOCUMENT: 'DOCUMENT' as TypesEnum,
    DOCUMENT_NAME: 'DOCUMENT_NAME' as TypesEnum,
    ORGANISATION_TYPE: 'ORGANISATION_TYPE' as TypesEnum,
  };
}
